import React from 'react';
import CommonGrid from './CommonGrid';
import { FormattedDate } from 'react-intl';
import { ColumnType } from '../../../../components/Grid/constants';

export default props => {
  const columns = [
    {
      sortable: false,
      field: 'person.firstName',
      displayField: 'person',
      label: 'Jméno žadatele',
      type: ColumnType.TEXT,
      mapper: field => field ? field.firstName : '',
      width: '15%'
    },
    {
      sortable: false,
      field: 'person.lastName',
      displayField: 'person',
      label: 'Příjmení žadatele',
      type: ColumnType.TEXT,
      mapper: field => field ? field.lastName : '',
      width: '15%'
    },
    {
      sortable: false,
      field: 'person.birthDate',
      label: 'Datum narození',
      type: ColumnType.JSX,
      jsx: row => (
        <div>
          {row.person && row.person.birthDate && <FormattedDate value={row.person.birthDate} />}
        </div>
      ),
      width: '8%'
    },
    {
      sortable: false,
      field: 'person.email',
      displayField: 'person',
      label: 'E-mail',
      type: ColumnType.TEXT,
      mapper: field => field ? field.email : '',
      width: '12%'
    },
    {
      sortable: false,
      field: 'person.databox',
      displayField: 'person',
      label: 'Datová schránka',
      type: ColumnType.TEXT,
      mapper: field => field ? field.databox : '',
      width: '8%'
    },
    {
      sortable: false,
      field: 'legalPerson.name',
      label: 'Právnická osoba žadatele',
      type: ColumnType.JSX,
      jsx: row => (
       <div>
        {row.legalPerson && row.legalPerson.name}
        {row.legalPerson && ' (IČO: '}
        {row.legalPerson && row.legalPerson.identificationNumber}
        {row.legalPerson && ')'}
       </div>
      ),
      width: '20%'
    },
    {
      sortable: false,
      field: 'text',
      label: 'Poznámka',
      type: ColumnType.TEXT,
      width: '22%'
    },
  ];

  return <CommonGrid {...props} columns={columns} />
}
